import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

import Button from '@material-ui/core/Button';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import useStyle from "../useStyles";

import moment from 'moment';

const ReunioesCard = (props) => {

  const {
    id,
    edicao,
    periodicidade,
    conselho,
    descricaoConselho,
    data,
    diaSemana,
    dataReuniao,
    hora,
    endereco,
    localReuniao,
    estado,
    cidade,
  } = props.info;

  const { history } = props;

  const {antigo} = props;

  const periodicidadesMap = { 'ORDINARIA': 'Ordinária', 'EXTRAORDINARIA': 'Extraordinária'};

  const label = `${edicao}ª Reunião ${periodicidadesMap[periodicidade]}`;

  const labelMes = {
    0: 'janeiro', 1: 'fevereiro', 2: 'março', 3: 'abril', 4: 'maio', 5: 'junho',
    6: 'julho', 7: 'agosto', 8: 'setembro', 9: 'outubro', 10: 'novembro', 11: 'dezembro'
  }

  // const campoMesAno = `${labelMes[parseInt(dataReuniao.split('/')[1])]}, ${dataReuniao.split('/')[2]}`

  const getMesAno = (stringData) => {
    let data = moment(stringData, 'YYYY-MM-DDTHH:mm:ss');
    return `${labelMes[data.month()]}, ${data.year()}`;
  }

  const relacaoDias = {
    0: 'Domingo',
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sabado'
  }

  const getDia = (stringData) => {
    let data = moment(stringData, 'YYYY-MM-DDTHH:mm:ss');
    return `${relacaoDias[data.day()]}, ${data.format('DD/MM/YYYY')}`;
  }

  const classes = useStyle();
  
  return (
    <div style={{marginRight:24}}>
      {/* <p className={classes.campoMesAno}>{campoMesAno}</p> */}
      <p className={classes.campoMesAno}>{getMesAno(data)}</p>
      <div className={classes.card}>
        <div className={antigo ? classes.imgCardGreen : classes.imgCard}>
          <Chip label={label} size="small" />
          <div className={classes.campoTextoImagemCard}>
            <p className={classes.campoTextoCard}>{descricaoConselho}</p>
          </div>
        </div>
        <div style={{ padding: 10 }}>
          <div className={classes.campoDataHoraCard}>
            <p>{getDia(data)}</p>
            <p><AccessTimeIcon style={{ fontSize: 14, verticalAlign: '-2px', marginRight: 5 }} />  {hora}</p>
          </div>
          <p className={classes.campoEnderecoCard}>{endereco}</p>
          {/* <p className={classes.campoEnderecoCard}>{localReuniao}</p> */}
          <p className={classes.campoEnderecoCard}>{`${cidade}, ${estado}`}</p>
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
            <Button variant="outlined" onClick={() => history.push(`/reuniao/${id}/visualizar`)} >Ver detalhes</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReunioesCard;
